import { FC } from "react";

import { ArrowDownward, ArrowUpward, DoubleArrowUp, PointFilled } from "@livechat/design-system-icons";
import { DesignToken, Icon, IconSize, IconSource } from "@livechat/design-system-react-components";

import { TicketPriority } from "interfaces/entities/ticket";
import { withVar } from "themes/helpers";

interface IProps {
  priority: TicketPriority;
  size?: IconSize;
  inline?: boolean;
  testId?: string;
}

const priorityIcon = (priority: TicketPriority): IconSource => {
  switch (priority) {
    case TicketPriority.Urgent:
      return DoubleArrowUp;
    case TicketPriority.High:
      return ArrowUpward;
    case TicketPriority.Low:
      return ArrowDownward;
    case TicketPriority.Medium:
    default:
      return PointFilled;
  }
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const priorityColor = (priority: TicketPriority) => {
  switch (priority) {
    case TicketPriority.Urgent:
    case TicketPriority.High:
      return withVar(DesignToken.ContentBasicNegative);
    case TicketPriority.Low:
      return withVar(DesignToken.ContentBasicPositive);
    default:
      return withVar(DesignToken.ContentBasicDisabled);
  }
};

const PriorityIndicator: FC<IProps> = ({ priority, ...iconProps }) => {
  const fill = priorityColor(priority);
  const name = priorityIcon(priority);

  return name ? <Icon source={name} customColor={fill} {...iconProps} /> : null;
};

export default PriorityIndicator;
